import {
  Box,
  Button,
  Divider,
  Heading,
  List,
  ListIcon,
  ListItem,
  Stack,
  Text,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  useDisclosure
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';
import Apply from './Apply';

const options = [
  { id: 1, desc: 'B.Tech/MCA/BCA' },
  { id: 2, desc: 'Other Equivalent Qualification' },
  { id: 3, desc: 'Plus Point - AWS Certification' },
];

const options3 = [
  { id: 1, desc: 'B.Tech/MCA/BCA' },
  { id: 2, desc: 'Other Equivalent Qualification' },
  { id: 3, desc: 'Plus Point - 3D Design Experience' },
];

const options2 = [
  { id: 1, desc: 'B.Com/MFA/CA/' },
  { id: 2, desc: 'Other Equivalent Qualification' },
  { id: 3, desc: 'Plus Point - AWS Certification' },
];

const PackageTier = ({
  title,
  options,
  typePlan,
  checked = false,
}) => {
  const colorTextLight = checked ? 'white' : '#22577A';
  const bgColorLight = checked ? '#22577A' : 'gray.300';

  const colorTextDark = checked ? 'white' : '#22577A';
  const bgColorDark = checked ? '#22577A' : 'gray.300';

  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Stack
      p={3}
      py={3}
      justifyContent={{
        base: 'flex-start',
        md: 'space-around',
      }}
      direction={{
        base: 'column',
        md: 'row',
      }}
      alignItems={{ md: 'center' }}>
      <Heading size={'md'}>{title}</Heading>
      <List spacing={3} textAlign="start">
        {options.map((desc, id) => (
          <ListItem key={desc.id}>
            <ListIcon as={FaCheckCircle} color="green.500" />
            {desc.desc}
          </ListItem>
        ))}
      </List>
      <Stack direction={'column'}>
      <Heading size={'lg'}>{typePlan}</Heading>
      <Heading size={'sm'}>Post Qualification Experience In Required Domain</Heading>
      </Stack>
      <Stack>
        <Button onClick={onOpen}
          size="md"
          color={useColorModeValue(colorTextLight, colorTextDark)}
          bgColor={useColorModeValue(bgColorLight, bgColorDark)}>
          Apply Now
        </Button>
      </Stack>
      <Modal isOpen={isOpen} onClose={onClose} size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton/>
                <Apply/>
            </ModalContent>
        </Modal>
    </Stack>
  );
};
const Career = () => {
  return (
    <Box py={6} px={5} min={'100vh'}>
      <Stack spacing={4} width={'100%'} direction={'column'}>
        <Stack
          p={5}
          alignItems={'center'}
          justifyContent={{
            base: 'flex-start',
            md: 'space-around',
          }}
          direction={{
            base: 'column',
            md: 'row',
          }}>
          <Stack
            width={{
              base: '100%',
              md: '40%',
            }}
            textAlign={'center'}>
            <Heading size={'lg'}>
              Current <Text color="#22577A">Opportunities</Text>
            </Heading>
          </Stack>
          <Stack
            width={{
              base: '100%',
              md: '60%',
            }}>
            <Text textAlign={'center'}>
            We are a dynamic organization driven by a young and enthusiastic bunch of people, who are our real strength. We love our work and our workplace. The challenges at work turn a humdrum day into an adventure. While the team spirit makes even the most difficult task seem easy.
            </Text>
          </Stack>
        </Stack>
        <Divider />
        <PackageTier title={'Associate Solutions Architech'} typePlan="1 Year +" options={options} />
        <Divider />
        <PackageTier title={'Senior Solutions Architech'} checked={true} typePlan="3 Years +" options={options}/>
        <Divider />
        <PackageTier title={'Lead Solutions Architech'} typePlan="6 Years +" options={options} />
        <Divider />
        <PackageTier title={'Cloud Support Engineers'} checked={true} typePlan="2 Years +" options={options} />
        <Divider />
        <PackageTier title={'Senior Accountant'} typePlan="2 Years +" options={options2} />
        <Divider />
        <PackageTier title={'React Native Developer'} checked={true} typePlan="2-5 Years" options={options3} />
        <Divider />
      </Stack>
    </Box>
  );
};

export default Career;